import type { FC } from "react";
import { TextBody } from "@/ui/components/typography/TextBody";
import {
  FOOTER_SECONDARY_TEXT_CLASS_NAME,
  type TFooterNavigationLink,
} from "./Footer.config";

type TFooterSecondaryNavigationListProps = {
  links: readonly TFooterNavigationLink[];
};

export const FooterSecondaryNavigationList: FC<TFooterSecondaryNavigationListProps> = ({
  links,
}) => (
  <nav
    aria-label="Secondary footer navigation"
    data-component="FooterSecondaryNavigationList"
    className="mx-auto max-w-[320px] px-3 pb-4 pt-8 xl:max-w-none xl:px-0 xl:pb-16"
  >
    <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 xl:gap-x-8">
      <li>
        <TextBody
          tag="span"
          color="inherit"
          size={2}
          isResponsive={false}
          className={FOOTER_SECONDARY_TEXT_CLASS_NAME}
        >
          { `© KatKin ${new Date().getFullYear()}` }
        </TextBody>
      </li>
      { links.map((link) => (
        <li key={link.id}>
          <TextBody
            tag="span"
            color="inherit"
            size={2}
            isResponsive={false}
            className={FOOTER_SECONDARY_TEXT_CLASS_NAME}
          >
            <a href={link.href}>
              { link.label }
            </a>
          </TextBody>
        </li>
      )) }
    </ul>
  </nav>
);

FooterSecondaryNavigationList.displayName = "FooterSecondaryNavigationList";
